export const SSO_ID = 13;
export const TNA_GB_ID = 1;
export const TNA_AU_ID = 14;

export const TNA_IDS = [TNA_GB_ID, TNA_AU_ID];
